function thumbtackQueryBusinesses () {
  const query = thumbtackInputQuery();
  const zip = thumbtackInputZip();
  const queryProperties = thumbtackQueryProperties(query, zip);
  const queryParams = thumbtackQueryParams(queryProperties);

  if (!queryProperties.query || !queryProperties.zip) {
    thumbtackToggleDefaultView(true);
    thumbtackToggleListView(false);
    return;
  }

  thumbtackToggleLoading(true);

  $.ajax({
      url: `/thumbtack?${queryParams}`,
      dataType: 'json',
      method: 'get',
      timeout: (60 * 1000) // 60 seconds
    })
    .done(function (result) {
      // General error
      if (result['error']) {
        thumbtackToggleDefaultView(true, result['error']);
        thumbtackToggleListView(false);
      }
      // Thumbtack error
      else if (result['errors']) {
        thumbtackToggleDefaultView(true, result['title']);
        thumbtackToggleListView(false);
      }
      // Success
      else {
        thumbtackListBusinesses(result);
      }
    })
    .fail(function (jqXHR, textStatus) {
      thumbtackToggleDefaultView(true, 'Timed out. Please try again.');
      thumbtackToggleListView(false);
    })
    .always(function () {
      thumbtackToggleLoading(false);
    })
    .then(function () {
      thumbtackToggleLoading(false);
    });
}

function thumbtackQueryProperties (query, zip) {
  return {
    query: (query) ? encodeURIComponent(query) : null,
    zip: (zip.length === 5) ? zip : null
  };
}

function thumbtackQueryParams (params) {
  const removeNull = function (obj) {
    return Object.fromEntries(
      Object.entries(obj)
        .filter(([_key, value]) => value != null)
        .map(([key, value]) => [
          key,
          value === Object(value) ? removeNull(value) : value,
        ])
    );
  };
  return new URLSearchParams(removeNull(params)).toString();
}

function thumbtackListBusinesses (results) {
  thumbtackToggleDefaultView(false);
  thumbtackToggleListView(true);
  thumbtackToggleLoading(false);

  const destination = document.querySelector('#thumbtackModal .thumbtack-results');
        destination.innerHTML = '';

  const businesses = results.data || [];
  businesses.forEach(business => {
    thumbtackAppendBusiness(business);
  });

  destination.parentNode.scrollTop = 0;
}

function thumbtackAppendBusiness (business) {
  const template = document.querySelector('#thumbtackProTemplate');
  let clone = template.content.cloneNode(true);

  // Business ID
  clone.querySelector('.panel-thumbtack-modal').setAttribute('data-business-id', business['businessID']);
  // Business name
  clone.querySelector('.panel-name').textContent = business['businessName'];
  // Avatar
  clone.querySelector('.panel-avatar').style.backgroundImage = `url(${business['businessImageURL']})`;
  // Rating
  clone.querySelector('.panel-rating').textContent = thumbtackRating(business['rating']);
  // Reviews
  clone.querySelector('.panel-reviews').textContent = thumbtackReviews(business['numberOfReviews']);
  // Introduction
  clone.querySelector('.panel-query').innerHTML = thumbtackIntroduction(business['businessIntroduction']);
  // Location
  clone.querySelector('.panel-location').textContent = business['businessLocation'];
  // Cost
  if (thumbtackCost(business['quote'])) {
    clone.querySelector('.panel-cost').textContent = thumbtackCost(business['quote']);
  }
  // Link to profile
  clone.querySelector('.panel-view a').setAttribute('href', business['servicePageURL']);
  // Pro badge
  if (!business['isTopPro']) {
    clone.querySelector('.panel-top-pro').style.display = 'none';
  }

  document.querySelector('#thumbtackModal .thumbtack-results').appendChild(clone);
}

function thumbtackIntroduction (introduction) {
  return introduction.replace(/\\n/g, '<br>')
                     .replace(/\n/g, '<br>');
}

function thumbtackCost (cost) {
  if (!cost || !cost['startingCost']) {
    return null;
  }

  const calculatedCost = parseFloat(cost['startingCost']) / 100;

  if (!cost['costUnit']) {
    return `From $${calculatedCost}`;
  } else {
    return `From $${calculatedCost} / ${cost['costUnit']}`;
  }
}

function thumbtackRating (rating) {
  return (rating) ? parseFloat(rating).toFixed(1) : 'N/A';
}

function thumbtackReviews (count) {
  return `(${count})`;
}

function thumbtackInputQuery () {
  return document.getElementById('thumbtack-query').value.trim();
}

function thumbtackInputZip () {
  return document.getElementById('thumbtack-zip').value.trim();
}

function thumbtackUtmSource () {
  return document.querySelector('#thumbtackModal').dataset.utmSource;
}

function thumbtackToggleDefaultView (show, error_message = null) {
  const display = document.querySelector('#thumbtackModal .thumbtack-default');
  const displayStart = display.querySelector('div.start');
  const displayError = display.querySelector('div.error');

  if (error_message) {
    displayStart.style.display = 'none';
    displayError.textContent = error_message;
    displayError.style.display = 'block';
  } else {
    displayStart.style.display = 'block';
    displayError.style.display = 'none';
  }

  display.style.display = show ? 'block' : 'none';
}

function thumbtackToggleLoading (show) {
  const loader = document.querySelector('#thumbtackModal .header-progress-loader');
  if (show) {
    loader.classList.add('loading');
    return;
  } else {
    loader.classList.remove('loading');
  }
}

function thumbtackToggleListView (show) {
  const display = document.querySelector('#thumbtackModal .thumbtack-results');
  display.style.display = show ? 'block' : 'none';
}

let thumbtackTimer;

function thumbtackDefaultDisplay () {
  thumbtackToggleDefaultView(true);
  thumbtackToggleListView(false);
}

function thumbtackInputWatcher () {
  const inputFields = ['#thumbtack-query', '#thumbtack-zip'];

  inputFields.forEach(function(inputField) {
    const element = document.querySelector(inputField);
    element.addEventListener('input', function (evt) {
      clearTimeout(thumbtackTimer);
      thumbtackTimer = setTimeout(function() {
        thumbtackQueryBusinesses();
      }, 500);
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  const thumbtackModal = document.getElementById('thumbtackModal');
  if (thumbtackModal) {
    thumbtackDefaultDisplay();
    thumbtackInputWatcher();
  }
})
